module.exports = __webpack_public_path__ + "static/media/bell-plus.8bd3f0e9.svg";